import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 79 141" {...props}><path fill="currentColor" stroke="currentColor" d="M64.5 2.9C72-4.6 83.7 7 76.2 14.5l-56 56 56 56c7.5 7.5-4.1 19.1-11.6 11.6L2.8 76.3c-3.1-3.2-3.1-8.4 0-11.6L64.5 2.9z" /></svg>);